var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{pre:true,attrs:{"class":"alex-map"}},[_c('angular-alex-map',{pre:true})],1)}
var staticRenderFns = []

export { render, staticRenderFns }